export const VIDEO_SUFFIXES = ['mp4', 'flv', 'avi']

export const EXCEL_SUFFIXES = ['xls', 'xlsx']

export const WORD_SUFFIXES = ['doc', 'docx']
